module.exports = __webpack_public_path__ + "img/Krungsri.a56da698.png";